import { types } from '../types/alertTypes';

type AlertState = { show: boolean; payload?: Record<string, unknown> };
type AlertAction = { type: string; payload?: Record<string, unknown> };

const defaultStore: AlertState = {
	show: false,
};

export const alertReducer = (
	state: AlertState = defaultStore,
	action: AlertAction,
) => {
	switch (action.type) {
		case types.success:
			return {
				show: true,
				payload: {
					...action.payload,
					variant: 'success',
				},
			};

		case types.warning:
			return {
				show: true,
				payload: {
					...action.payload,
					variant: 'warning',
				},
			};

		case types.danger:
			return {
				show: true,
				payload: {
					...action.payload,
					variant: 'danger',
				},
			};

		case types.remove:
			return {
				...state,
				show: false,
			};

		case types.info:
			return {
				show: true,
				payload: {
					...action.payload,
					variant: 'info',
				},
			};

		default:
			return state;
	}
};
